import React, { useEffect } from 'react'
import './App.css'
import 'react-calendar/dist/Calendar.css'
import { HashRouter, Route } from 'react-router-dom'
import SignUp from './components/auth/SignUp'
import Scheduler from './components/Scheduler'
import Pricing from './components/Pricing'
import Schedule from './components/Schedule'
import SignUps from './components/auth/SignUps'
import useSchedule from './state-management/actions/auth/useSchedule'

const App = () => {

  return (
    <HashRouter>
      <div className="App">
        <Route exact path="/" component={Pricing} />
        <Route exact path="/pricing" component={Pricing} />
        <Route exact path="/sign-up" component={SignUp} />
        <Route exact path="/signup" component={SignUps} />
        <Route exact path="/scheduler" component={Schedule} />
        {/* <Route exact path="/signup-turbo/:reference?" component={Turbos} /> */}
        <Route exact path="/schedule/:reference?" component={Scheduler} />
      </div>
    </HashRouter>
  )
}

export default App
